import { calculateAge } from "@/pages/household/UP/up-utils";
import { Household } from "@/types/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type HeaderState = {
  title: string | React.ReactNode;
  content?: string;
  isLoading?: boolean;
  isError?: boolean;
};

type InitialState = {
  header: HeaderState;
  household: Household | null | Partial<Household>;
  age1: number;
  age2: number | undefined;
  isAge1Incremented?: boolean;
  isAge2Incremented?: boolean;
};

const initialState: InitialState = {
  header: {
    title: "",
    content: "",
    isLoading: false,
    isError: false,
  },
  household: null,
  age1: 0,
  age2: undefined,
};

const householdSlice = createSlice({
  name: "householdDetails",
  initialState,
  reducers: {
    setHeader(state, action: PayloadAction<HeaderState>) {
      state.header = action.payload;
    },
    setHousehold(state, action: PayloadAction<Household | Partial<Household>>) {
      const payloadHH = action.payload;

      state.age1 = calculateAge(payloadHH?.primaryContact?.birthDate, 0)?.value;
      state.isAge1Incremented = calculateAge(
        payloadHH?.primaryContact?.birthDate,
        0
      )?.isIncremented;
      if (!payloadHH?.isSingle) {
        state.age2 = calculateAge(payloadHH?.secondaryContact?.birthDate, 0)?.value;
        state.isAge2Incremented = calculateAge(
          payloadHH?.secondaryContact?.birthDate,
          0
        )?.isIncremented;
      }

      state.household = payloadHH;
    },
  },
});

export const householdActions = householdSlice.actions;
export default householdSlice;
